import { PureComponent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isCordova } from 'utils/platform';

class BackUrlHandler extends PureComponent<RouteComponentProps> {

  componentDidMount() {
    // Check if we have backUrl in query params
    if (this.props.location && this.props.location.search && this.props.location.search.includes('backUrl')) {
      const params = new URLSearchParams(this.props.location.search.substr(1));
      const backUrl = params.get('backUrl');
      if (!!backUrl) {
        // strip off backurl
        if (!isCordova()) {
          params.delete('backUrl');
        }
        const newLocation = {
          ...this.props.location,
          search: `?${params.toString()}`,
        };
        if (isCordova()) {
          this.props.history.replace(backUrl);
          this.props.history.push(newLocation);
        } else {
          setTimeout(() => {
            this.props.history.replace(backUrl);
            this.props.history.push(newLocation);
          });
        }
      }
    }
  }

  render() {
    return null;
  }
}

export default withRouter(BackUrlHandler);
